<div class="ttm-page-title-row clearfix" style="background: #293649;  ">
    <div class="container">

        <div class="col-md-12">
            <div class="title-box text-center">
                <div class="page-title-heading">
                    <h1 class="title" style="color:white"> Timeline</h1>
                </div><!-- /.page-title-captions -->

            </div>
        </div><!-- /.col-md-12 -->
    </div><!-- /.container -->
</div>
<div class="site-main">
    <!-- services-slide-section -->
    <section class="contact-section clearfix">
        <!-- row end -->
        <!-- row -->
        <div class="bg-img7">
            <div class="container">
                <section class="ttm-row tab-section clearfix mt-3" id="services">

                    <!-- row end -->
                    <!-- row -->
                    <div class="col-lg-12">
                        <div class="content-center">



                            <ul class="timeline">
                                <!-- Item 1 -->
                                <li class="widthovers">
                                    <div class="direction-r rights">
                                        <div class="ag-center  mbs-20">
                                            <!--<div class="col-md-2">-->
                                            <div class="flag-wrapper">

                                                <span class="flag">2023</span>

                                            </div>
                                            <!--</div>-->
                                            <!--<div class="col-md-8">-->
                                            <div class="desc">An office was opened in New York City as a result
                                                of accelerated growth.</div>
                                            <!--</div>-->
                                        </div>


                                    </div>

                                </li>
                                <!-- Item 2 -->
                                <li class="w-81">
                                    <div class="direction-l rights mbs-20">
                                        <div class="ag-center flexs flexs-r">

                                            <!--<div class="col-md-8">-->
                                            <div class="desc mr-desc1">An office was opened in Bhubaneswar,
                                                India as a result of increasing demand.</div>
                                            <!--</div>-->
                                            <!--<div class="col-md-2">-->
                                            <div class="flag-wrapper">

                                                <span class="flag">2022</span>

                                            </div>
                                            <!--</div>-->
                                        </div>


                                    </div>

                                </li>
                                <li class="widthover">
                                    <div class="direction-r rights">
                                        <div class="ag-center  mbs-20">
                                            <!--<div class="col-md-2">-->
                                            <div class="flag-wrapper">

                                                <span class="flag">2021</span>

                                            </div>
                                            <!--</div>-->
                                            <!--<div class="col-md-8">-->
                                            <div class="desc"><strong
                                                    style="text-decoration:underline">Qualibar</strong> was
                                                established to focus on custom software development, AI/ML &
                                                Quality Assurance (QA) Services while KGS focused on software
                                                training.</div>
                                            <!--</div>-->
                                        </div>


                                    </div>

                                </li>

                                <!-- Item 2 -->
                                <li class="w-78">
                                    <div class="direction-l rights mbs-20">
                                        <div class="ag-center flexs flexs-r">

                                            <!--<div class="col-md-8">-->
                                            <div class="desc mr-desc1">Started developing the next generation of
                                                platforms to support InsureTech/Healthcare IT/Payments.</div>
                                            <!--</div>-->
                                            <!--<div class="col-md-2">-->
                                            <div class="flag-wrapper">

                                                <span class="flag">2019</span>

                                            </div>
                                            <!--</div>-->
                                        </div>


                                    </div>

                                </li>

                                <!-- Item 3 -->
                                <li class="w-93">
                                    <div class="direction-r rights mbs-20">
                                        <div class="ag-center flexs">
                                            <!--<div class="col-md-2">-->
                                            <div class="flag-wrapper">

                                                <span class="flag">2014</span>

                                            </div>
                                            <!--</div>-->
                                            <!--<div class="col-md-8">-->
                                            <div class="desc">Secured a contract to develop the next generation
                                                of Payment Technology Platforms.</div>
                                            <!--</div>-->
                                        </div>


                                    </div>
                                    <div class="line-bottom"></div>
                                </li>
                                <!-- Item 4 -->
                                <li class="w-58">
                                    <div class="direction-l rights mbs-20">
                                        <div class="ag-center flexs flexs-r">

                                            <!--<div class="col-md-8">-->
                                            <div class="desc mr-desc">The eWallet payment business was acquired
                                                by VAST Group.</div>
                                            <!--</div>-->
                                            <!--<div class="col-md-2">-->
                                            <div class="flag-wrapper">

                                                <span class="flag">2010</span>

                                            </div>
                                            <!--</div>-->
                                        </div>
                                    </div>
                                    <div class="line-top"></div>
                                </li>

                                <!-- Item 5 -->
                                <li class="w-67 li">

                                    <div class="direction-r direction-rw rights mbs-20">

                                        <div class="ag-center flexs">
                                            <!--<div class="col-md-2">-->
                                            <div class="flag-wrapper">

                                                <span class="flag">2007</span>

                                                <!--</div>-->
                                            </div>
                                            <!--<div class="col-md-10">-->
                                            <div class="desc">KGS was formed to provide bespoke software
                                                development services for the financial services industry. The
                                                team started building the eWallet platform.</div>
                                        </div>
                                        <!--</div>-->


                                    </div>
                                    <div class="line-bottom"></div>
                                </li>
                            </ul>

                        </div>
                    </div>


                </section>

            </div>

        </div>

        <!-- row end-->

    </section>
    <!-- services-slide-section end -->
</div>